<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
	<div>
		<div class="serviceform-lomake"></div>
	</div>
</template>

<script setup lang="ts"></script>
